module.exports = __webpack_public_path__ + "img/ico_info_blue.a6e40563.svg";